import { useQuery } from 'query';
import { getInvitationToken } from '../services';
import { getInvitationTokenQueryKey } from './keys';

export const useGetInvitationToken = ({ communityId }: { communityId: string }) =>
  useQuery<string>({
    enabled: Boolean(communityId),
    async queryFn() {
      const response = await getInvitationToken({ communityId });
      // TODO: return all data not only token, create for that model
      return response.data.token;
    },
    queryKey: getInvitationTokenQueryKey({ communityId }),
  });
